<template>
  <SelectorPanel
    type="assetsEos"
    text="Assets (Eos)"
    :force-full-screen="true"
    :disabled="disabled"
  >
    <EosIframe :route="eosRoute" height="100vh" :key="eosRoute" />
  </SelectorPanel>
</template>

<script>
const EOS_ASSETS_ROUTE = "/seerist/assets";

export default {
  name: "AssetsEosSelector",
  components: {
    SelectorPanel: () => import("@/components/common/SelectorPanel.vue"),
    EosIframe: () => import("@/components/eos/EosIframe"),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      eosRoute: EOS_ASSETS_ROUTE,
    };
  },
};
</script>
